import { IconArrowDown } from '@components/atoms/icons'
import Image from '@components/atoms/image'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import useStyles from './we-love-this-game-hero.styles'

const WeLoveThisGameHero = (props) => {
  const {
    hero,
    logo,
    heroText,
    heroMobile,
  } = props

  const images = {
    sm: heroMobile.url
      ? `${heroMobile.url}?fm=jpg&fl=progressive&q=80`
      : '',
    lg: hero.url
      ? `${hero.url}?fm=jpg&fit=fill&fl=progressive&q=80`
      : '',
  }

  const styles = useStyles({ images })
  return (
    <Box
      className={styles.root}
      display="flex"
      flexDirection="column"
    >
      <Box className={styles.imageContainer}>
        <Box className={styles.contentContainer}>
          {logo && logo.url
            && <Image className={styles.logo} src={`${logo.url}?h=300`} alt={logo.description} />}
          <Typography variant="h1" variantMapping={{ h5: 'h2' }} className={styles.header}>
            {heroText}
          </Typography>
        </Box>
      </Box>
      <Box className={styles.halfCircle} aria-hidden>
        <IconArrowDown className={styles.halfCircleArrow} />
      </Box>
    </Box>
  )
}

WeLoveThisGameHero.propTypes = {
  hero: PropTypes.object,
  heroMobile: PropTypes.object,
  logo: PropTypes.object,
  heroText: PropTypes.string,
}

WeLoveThisGameHero.defaultProps = {}

export default WeLoveThisGameHero
